const CN_CUSTOM = {


  // Temporary EN placeholders for parity. Replace with translated strings.
  "chargingStations.mapLegend.high": "High Power Stations",
  "chargingStations.mapLegend.highSubtext": "DC fast charge or superchargers",
  "chargingStations.mapLegend.other": "Other Types of Stations",
  "chargingStations.mapLegend.private": "Private Stations",
  "chargingStations.mapLegend.public": "Public Stations",
  "chargingStations.mapLegend.publicSubtext": "Installed by business or government",
  "contact": "Contact",
  "currency": "$",
  "electricians.fastEfficient": "{title} Our install timelines are secured and expedited to help get you up and running sooner.",
  "electricians.map.header": "Benefits of our Preferred Partners",
  "electricians.map.personalizedExperience": "{title} Our EV Specialists can help guide you through the entire process.",
  "electricians.map.value": "{title} We offer competitive installation prices.",
  "electricians.worldClass": "{title} We partner with experienced electricians who are vetted to ensure a safe and professional installation",
  "ev.carDetails.calc.charging": "Charging",
  "ev.carDetails.calc.DCFC": "DC Fast Charging (DCFC) Rate",
  "ev.carDetails.calc.description": "Description",
  "ev.cardetails.calc.electricEmissionsLbsMwhMetric": "Electric Emissions in Kg/MWh",
  "ev.cardetails.calc.electricEmissionsMetric": "Electric Emissions in kg",
  "ev.cardetails.calc.electricityEmissionsMetric": "Electricity Emissions in CO2 kg/MWh",
  "ev.carDetails.calc.emissions": "Emissions",
  "ev.cardetails.calc.emissionsReductions": "Emissions Reductions",
  "ev.cardetails.calc.EPAMetric": "NRC Efficiency Rating",
  "ev.carDetails.calc.fuel": "Fuel",
  "ev.cardetails.calc.FuelConsumptionCa": "Canada Fuel Consumption Guide",
  "ev.cardetails.calc.gasolineEmissionskg": "Gasoline Emissions in Kg",
  "ev.cardetails.calc.gasolineEmissionsMetric": "Gasoline Emissions in Kg per Liter",
  "ev.cardetails.calc.gasolineEmissionsYrMetric": "Gasoline Emissions in kg of CO2/yr",
  "ev.cardetails.calc.kgCo2PerYr": " kgs of CO2 per year",
  "ev.cardetails.calc.kmDrivenPerYr": "Kilometers Driven Per Year",
  "ev.carDetails.calc.kwPerKm": "kWh per 100 km",
  "ev.carDetails.calc.kwPerMile": "kWh per 100 mi",
  "ev.cardetails.calc.litersSaved": "Liters Saved",
  "ev.cardetails.calc.litersSavedFormula": "Liters used by Equivalent Gas Vehicle - Liters used by EV",
  "ev.cardetails.calc.litersUsed": "Liters Used",
  "ev.cardetails.calc.litersUsedFormula": "Kilometers driven * (1 - Portion of Electric Driving) * L/100 km",
  "ev.cardetails.calc.lPer100Km": "L/100 km",
  "ev.cardetails.calc.lPerKm": "Liters Per 100 Kilometers",
  "ev.cardetails.calc.lpkm": " liters/kilometer",
  "ev.carDetails.calc.milesDriven": "Miles Driven Per Year",
  "ev.carDetails.calc.milesPerGallonBasic": "Miles Per Gallon",
  "ev.cardetails.calc.nationalAverageElectricityEmissions": "National Average Electricity Emissions",
  "ev.carDetails.calc.source": "Source",
  "ev.carDetails.kilometerBatterySizeTooltip": "One kilowatt-hour (kWh) is enough energy to drive 1 to 4 miles, depending on the vehicle. A typical laptop battery can hold less than 0.1 kWh.",
  "ev.carDetails.kilometerUsedBatterySizeTooltip": "One kilowatt-hour (kWh) is enough energy to drive 1 to 4 kilometers, depending on the vehicle. To account for battery degradation for a used EV, the battery size quoted here is an estimation based on the age of the vehicle and normal driving/charging patterns.",
  "ev.carDetails.mobile": "For more details including charts {amp} calculations, please view this page on a desktop.",
  "ev.carDetails.view": "View vehicle details",
  "ev.chargingStations.body": " It's easier than ever to charge on the go. Enter your location to {lineBreak} see all charging stations near you.",
  "ev.costOfPublicCharing": "Est. cost of public charging",
  "ev.dealers.body": "Discover electric vehicle dealers in your area, and click on each one to see location and contact information.",
  "ev.incentives.title.simple": "Available Incentives and Rebates",
  "ev.jumbotron.findADealer": "Find a Dealer",
  "ev.kilometersDrivenAnnually": "Kilometers Driven Per Year",
  "ev.matchScore.adjustment": "Adjustment",
  "ev.matchScore.budget": "Budget",
  "ev.matchScore.charging": "Charging",
  "ev.matchScore.maxScore": "Max Score",
  "ev.matchScore.popover": "Your Match Score is based on your selected preferences.",
  "ev.matchScore.range": "Range",
  "ev.matchScore.seats": "Seats",
  "ev.matchScore.title": "Match Score",
  "ev.matchScore.totalScore": "Total Score",
  "ev.matchScore.yourScore": "Your Score",
  "ev.planningRoute.body": "It’s easier than ever to charge on the go. Enter your destination to see all of the charging stations along the way.",
  "ev.public": "Public",
  "ev.publicPrivateCharging": "Mix public/private charging",
  "ev.showSources.blendedMaintenanceCostPerKilometer": "Blended maintenance cost per kilometer",
  "ev.showSources.blendedMaintenanceCostPerKilometerSource": "Portion of Electric Driving applied to Maintenance per kilometer for gasoline and for electricity",
  "ev.showSources.dollarPerKilometerDriven": "$/100 km driven",
  "ev.showSources.dollarPerKilometerDrivenPublicCharging": "(Estimated Cost of Public Charging * Mix Public/Private Charging + Electricity Rate * (1 - Mix Public/Private Charging)) * Vehicle kWh per 100 km",
  "ev.showSources.dollarPerKilometerDrivenSource": "Electricity Cost * Vehicle's kWh per 100 km",
  "ev.showSources.dollarPerMileDrivenPublicCharging": "(Estimated Cost of Public Charging * Mix Public/Private Charging + Electricity Rate * (1 - Mix Public/Private Charging)) * Vehicle kWh per 100 mi",
  "ev.showSources.estimatedCostOfPublicCharging": "Estimated Cost of Public Charging",
  "ev.showSources.insuranceSource": "Average Insurance Cost In ",
  "ev.showSources.kilometerVehicleKWh": "Vehicle's kWh per 100 km",
  "ev.showSources.lifetimeKilometers": "Lifetime Kilometers",
  "ev.showSources.maintenancePerKilometer": "Maintenance per kilometer for gasoline",
  "ev.showSources.maintenancePerKilometerElectricity": "Maintenance per kilometer for electricity",
  "ev.showSources.maintenancePerKilometerElectricitySource": "Maintenance per kilometer for gasoline * EV Maintenance Reduction Factor",
  "ev.showSources.mixPublicPrivateCharging": "Mix Public/Private Charging",
  "ev.showSources.portionElectricSourceKilometer": "User input. For a hybrid vehicle, estimates the portion of kilometers driven using the electric battery instead of gasoline.",
  "ev.showSources.totalKilometerElectricityCostSource": "$/100 km driven * Lifetime Kilometers * {portionEVDriving}/ 100",
  "ev.showSources.totalKilometerGasolineCostSource": "Gasoline Cost * Lifetime Kilometers *  {portionEVDriving}/ lPerKm",
  "ev.showSources.totalKilometerMaintenanceCostSource": "Maintenance cost per kilometer * Lifetime Kilometers",
  "ev.showSources.vehiclelPerKm": "Vehicle's LPerKm (liters per kilometer)",
  "ev.used.electricRange": "Electric Range Average",
  "ev.used.yearRange": "Year Range",
  "eventCard.hostedBy": "Hosted by",
  "eventCard.inPerson": "In Person Event",
  "eventCard.inPersonAndVirtual": "In Person + Virtual Event",
  "eventCard.learnMore": "Learn More",
  "eventCard.virtualEvent": "Virtual Event",
  "eventCatalog.noEvents": "No events matching your current search criteria can be found. Try changing your search criteria",
  "eventCatalog.noMatch": "We didn't find any matches.",
  "events": "Events",
  "events.allLocations": "All Locations",
  "events.autoshow": "Autoshow",
  "events.conference": "Conference",
  "events.distance": "Distance",
  "events.educationEvent": "Education Event",
  "events.inPerson": "In Person",
  "events.inPersonOrVirtual": "In Person or Virtual",
  "events.nationWide": "Nationwide",
  "events.rideAndDrive": "Ride and Drive",
  "events.subHeader": "See, touch and feel an electric vehicle for yourself at an upcoming event.",
  "events.training": "Training",
  "events.virtual": "Virtual",
  "events.webinar": "Webinar",
  "eventsDateRange": "Date Range",
  "eventsFilters": "Filters",
  "eventSort.dateLtH": "Date (Soonest first)",
  "evs.chargerCatalog.noChargers": "No Chargers found",
  "evs.graph.compare": "Compare electric cars by EV range or price. Hover on the EV for more details.",
  "evs.graph.disclaimer": "Vehicles displayed may not reflect actual availability. {companyName} does not endorse or recommend any specific vehicle or car manufacturer.",
  "evs.graph.mobile": "To see the Range vs. Cost Graph, please view this page on a desktop.",
  "evs.graph.rangeVsCost": "Range vs. Cost",
  "evs.graph.tiles": "Vehicle Tiles",
  "evs.graph.title": "Electric Vehicles",
  "evs.highPower.legend": "High Power Stations",
  "evs.other.legend": "Other Types of Stations",
  "evs.public.legend": "Public Stations",
  "evs.welcomeSubMobile": "Tailor your search to discover electric vehicles that fit your needs.",
  "FAQ": "FAQ",
  "footer.copyright": "© 1998-2026 San Diego Gas & Electric Company. The trademarks used herein are the property of their respective owners. All rights reserved.",
  "footer.disclaimer": "{COMPANY_NAME}® Company is a subsidiary of Sempra®. SDG&E® and San Diego Gas & Electric are registered trademarks of San Diego Gas & Electric Company.",
  "footer.ratepayerDisclaimer": "The messages contained on this site are funded by ratepayers unless otherwise noted.",
  "footer.zappyDisclaimer": "Figures shown on this page are estimates based on data provided by third-parties. This material is provided for informational purposes only and should not be relied on for tax, legal, or financial advice. Neither J.D. Power® nor SDGE provides tax, legal or financial advice. You should independently verify the estimates provided here before engaging in any transaction.",
  "footer.zappyDisclaimer.one": "EV solutions © 2026 J.D. Power, provided with permission.",
  "ft": "ft",
  "galperyear": "gal/yr",
  "graph.costDifferent": "Why is the cost different?",
  "graph.costVsRange.afterIncentives": "From at {price} after incentives",
  "graph.costVsRange.electricKilometerRange": "Electric Range: {kilometers} kilometers",
  "graph.costVsRange.electricRange": "Electric Range: {miles} miles",
  "graph.electricRange.assumptions": "Assumptions",
  "graph.electricRange.description": "Description",
  "graph.electricRange.electricity": "Electricity",
  "graph.electricRange.gasoline": "Gasoline",
  "graph.electricRange.total": "Total",
  "graph.fuelRange.chart.chargedHome": "charged at home",
  "graph.fuelRange.chart.description": "Description",
  "graph.fuelRange.chart.fuelBudget": "fuel budget",
  "graph.fuelRange.chart.howFar": "How far can you drive the {car} on a {budget} fuel budget?",
  "graph.fuelRange.chart.kilometers": "kilometers",
  "graph.fuelRange.chart.miles": "miles",
  "graph.fuelRange.chart.network": "on Plug-In EVerywhere network",
  "graph.fuelRange.chart.rangeOn": "Range on",
  "graph.fuelRange.chart.similarGas": "a similar Gas Vehicle",
  "graph.fuelRange.chart.unlimited": "Unlimited",
  "graph.showCostBreakdown": "Show Cost Breakdown",
  "graph.speedOfCharge.kilometersLevelTwoChargerThreeCars": "charges the most kilometers per hour with a level 2 charger",
  "graph.speedOfCharge.kilometersThirtyFastChargeThreeCars": "charges the most kilometers per 30 minutes of fast charging",
  "graph.speedOfCharge.kmLevelTwoCharger": "kilometers per hour with a level 2 charger",
  "graph.speedOfCharge.kmThirtyFastCharge": "kilometers per 30 minutes of fast charging",
  "graph.title.miles": "Miles",
  "graph.title.totalRange": "Total Range",
  "header.electricVehicles.v2": "Explore EVs",
  "header.home": "Home",
  "header.newVehicles": "Explore Electric Vehicle Options",
  "header.usedVehicles": "Explore Electric Vehicle Options",
  "home": "Home",
  "homeChargers.meterCable": "{length} m Cable",
  "homeChargers.selectMake": "Select a Make",
  "homeChargers.selectModel": "Select a Model",
  "homeChargers.title": "Home Chargers",
  "homepage.linkCard.findDealers": "Find {lineBreak} Dealers",
  "incentives.electricityProvider": "Electricity Provider",
  "incentives.householdIncomeTooltip": "Used to determine incentive eligibility. Include all members of your household (spouse, dependents, etc.). Few to no incentives mention households larger than 8 members, so select 8 if your household size is 8 or larger.",
  "incentives.householdSizeTooltip": "Include all members of your household (spouse, deoendants, etc). Used to determine incentived eligibility.",
  "incentives.retiringVehicleTooltip": "Retiring an old gas vehicle may be required for certain incentives.",
  "incentives.taxFilingStatusTooltip": "Used to determine incentive eligibility.",
  "kgperyear": "kg/yr",
  "lbsperyear": "lbs/yr",
  "linkUnavailable": "Link to Network Unavailable",
  "literperyear": "L/yr",
  "loading": "Loading",
  "m": "m",
  "maps": "Maps",
  "pages": "Pages",
  "results.updated": "Results have been updated as of ",
  "vehicle.gasoline.metricPrice": "Gasoline Price ($/L)",
  "vehicle.gasoline.price": "Gasoline Price ($/gal)",
  "vehicle.kilometers": "kilometers",
  "vehicle.kilometersCapital": "Kilometers",
  "vehicle.kilometersPerThirtyFastCharge": "Kilometers per 30 min of fast charging",
  "vehicle.kilometersShort": "km",
  "vehicle.milesCaptital": "Miles",
  "vehicle.milesShort": "mi",
  "vehicles.none": "No vehicles found",
  "zipCode": "Zip Code",
}

export default CN_CUSTOM;